module.exports = __webpack_public_path__ + "static/img/Dustin_Martin_mobile.dd20814.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dustin_Martin_mobile.jpg
// module id = hQVf
// module chunks = 0